module.exports = __webpack_public_path__ + "img/4.4fd7eee1.png";